import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../atoms/icon/icon.component';

export interface ChecklistItem {
  text: string;
  icon?: string;
}

@Component({
  selector: 'htx-checklist',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './checklist.component.html',
  styleUrl: './checklist.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChecklistComponent {
  items = input.required<ChecklistItem[]>();
  icon = input<string>('check_circle');
}
